import { Calendar } from "primereact/calendar";
import { classNames } from "primereact/utils";
import { Controller } from "react-hook-form";
import { Tooltip } from "primereact/tooltip";
import { useRef, useEffect, useState } from "react";

interface IDate {
    label?: string;
    name: string;
    defaultValue?: string | number;
    control: any;
    error?: string;
    required?: boolean;
    disabled?: boolean;
    placeholder?: string;
    column?: number;
    maxDate?: Date;
    minDate?: Date;
    type?: string;
    tooltip?: string;
    rules?: any;
}

export const JVDate = (props: IDate) => {
    const className = props.column
        ? `field col-12 md:col-${12 / props.column}`
        : "field col-12 md:col-6";
    const type = props.type ?? "date";

    const tooltipRef = useRef<HTMLDivElement>(null);
    const [tooltipTarget, setTooltipTarget] = useState<HTMLElement | null>(null);

    // Set the DOM element after render
    useEffect(() => {
        if (tooltipRef.current) {
            setTooltipTarget(tooltipRef.current);
        }
    }, []);

    return (
        <div className={className}>
            {props.label && (
                <label htmlFor={props.name}>
                    {props.label}
                    {props.required && <span style={{ color: "red" }}>*</span>}
                </label>
            )}

            <div
                ref={tooltipRef}
                data-pr-tooltip={props.tooltip}
                data-pr-position="top"
            >
                <Controller
                    name={props.name}
                    control={props.control}
                    rules={props.rules}
                    defaultValue={props.defaultValue ?? ''}
                    render={({ field, fieldState }) => (
                        <Calendar
                            {...field}
                            view={type}
                            disabled={props.disabled}
                            className={classNames({ 'p-invalid': fieldState.invalid })}
                            placeholder={props.placeholder}
                            minDate={props.minDate}
                            maxDate={props.maxDate}
                            showButtonBar
                            dateFormat={
                                type === "date" ? "dd-mm-yy" :
                                    type === "year" ? "yy" :
                                        type === "month" ? "mm" : "dd-mm-yy"
                            }
                            showIcon
                        />
                    )}
                />
            </div>

            <small className="p-error">
                {props.error}
                <Controller
                    name={props.name}
                    control={props.control}
                    render={({ fieldState }) => (
                        <>{fieldState.error?.message}</>
                    )}
                />
            </small>

            {props.tooltip && tooltipTarget && (
                <Tooltip target={tooltipTarget} />
            )}
        </div>
    );
};
